import $ from 'jquery';
import _ from 'underscore';
import {
  CHANGE_SCHEDULE_SEASON,
  LOAD_SEASON_DETAILS,
  RECEIVE_FEED_USER_FOLLOWED,
  RECEIVE_FEED_USER_UNFOLLOWED,
  RECEIVE_TEAM_TAGLINE_UPDATED,
  RECEIVE_TEAM_IMAGE_UPDATED,
} from 'common/actions';

function team(state = {}, action) {
  let season;
  const newState = $.extend(true, {}, state);
  switch (action.type) {
  // Select a season in the schedule
  case CHANGE_SCHEDULE_SEASON:
    newState.allSeasons.forEach(s => {
      s.isSelected = s.id === action.payload.seasonId;
    });
    break;
  // Load schedule data from aync server request
  case LOAD_SEASON_DETAILS:
    const seasonId = action.payload.seasonId;
    const events = action.payload.data;

    season = _.findWhere(state.allSeasons, { id: seasonId });
    season.hasDetails = true; // don't try to load this again
    season.loadError = null;

    for (let i = 0; i < season.events.length; i++) {
      const event = season.events[i];
      const eventData = _.findWhere(events, { gameId: event.gameId });
      if (!eventData) continue;

      season.events[i] = _.extend(season.events[i], eventData);
    }
    newState.allSeasons = state.allSeasons;
    break;
  // Actions around following the team
  case RECEIVE_FEED_USER_FOLLOWED:
    if (action.payload.isCurrentProfile) {
      newState.followCount += 1;
    }
    break;
  case RECEIVE_FEED_USER_UNFOLLOWED:
    if (action.payload.isCurrentProfile) {
      newState.followCount -= 1;
    }
    break;
  case RECEIVE_TEAM_TAGLINE_UPDATED:
    newState.tagline = action.payload.teamTagline;
    break;
  case RECEIVE_TEAM_IMAGE_UPDATED:
    if (action.payload.imageType === 'TEAM_LOGO') {
      newState.teamLogoUri = action.payload.newImageSource;
    } else if (action.payload.imageType === 'TEAM_PHOTO') {
      newState.teamCoverImage = action.payload.newImageSource;
    } else {
      return state;
    }
    break;
  default:
    return state;
  }
  return newState;
}

export default team;
